const getModuleState = state => state.anagrams;
export const getAnagramsGame = state => getModuleState(state).game;
